import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const CrearCurso = ({onSuccess}) => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        nombre: "",
        encargado: "",
        tipo_curso: "",
        fecha_inicio: new Date().toISOString().split("T")[0],
        fecha_termino: new Date().toISOString().split("T")[0],
        lugar: "",
        horario: "",
        notas: "",
        status: "Activo"
    });

    const [tipoCursos, setTipoCursos] = useState([]);
    const [statusList, setStatusList] = useState([]);

    const fieldLabels = {
        nombre: "Nombre del Curso",
        encargado: "Encargado",
        tipo_curso: "Tipo de Curso",
        fecha_inicio: "Fecha de Inicio",
        fecha_termino: "Fecha de Término",
        lugar: "Lugar",
        horario: "Horario",
        notas: "Notas",
        status: "Estado"
    };

    // Listas desplegables
    useEffect(() => {
        setTipoCursos([
            { id: "Introducción", nombre: "Introducción" },
            { id: "Taller", nombre: "Taller" },
            { id: "Capacitación", nombre: "Capacitación" }
        ]);

        setStatusList([
            { id: "Activo", nombre: "Activo" },
            { id: "Suspendido", nombre: "Suspendido" },
            { id: "Finalizado", nombre: "Finalizado" }
        ]);
    }, []);

    // Convertir fecha de dd-mm-aaaa a formato ISO
    const parseDate = (dateString) => {
        if (!dateString) return "";
        const [day, month, year] = dateString.split("-");
        return `${year}-${month}-${day}`;
    };

    // Manejar cambios
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: ["tipo_curso", "status"].includes(name) ? value : value.toUpperCase()
        });
    };

    // Enviar formulario
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const dataToSend = { ...formData };
            dataToSend.fecha_inicio = parseDate(dataToSend.fecha_inicio);
            dataToSend.fecha_termino = parseDate(dataToSend.fecha_termino);

            await axios.post("http://192.168.1.81:5000/backend/api/cursos", dataToSend);

            alert("Curso creado con éxito");
            navigate("/cursos");
            if (onSuccess) onSuccess();
        } catch (error) {
            alert("Error al crear curso");
            console.error("Error al crear curso", error);
        }
    };

    return (
        <div className="container mt-5">
            <div className="card shadow-lg">
                <div className="card-body">
                    <h2 className="card-title text-center mb-4">Crear Nuevo Curso</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                            {Object.keys(formData).map((key) => (
                                <div key={key} className="col-md-6">
                                    <label className="form-label">{fieldLabels[key]}</label>
                                    {["tipo_curso", "status"].includes(key) ? (
                                        <select
                                            name={key}
                                            value={formData[key]}
                                            onChange={handleChange}
                                            className="form-select"
                                            required
                                        >
                                            <option value="">Seleccione...</option>
                                            {(key === "tipo_curso" ? tipoCursos : statusList).map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.nombre}
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        <input
                                            type={key.includes("fecha") ? "date" : key === "horario" ? "time" : "text"}
                                            name={key}
                                            value={FormData[key]}
                                            onChange={handleChange}
                                            className="form-control"
                                            placeholder={
                                                key.includes("fecha")
                                                    ? "DD-MM-AAAA"
                                                    : `Ingrese ${fieldLabels[key] || key}`
                                            }
                                            required
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                        <button type="submit" className="btn btn-primary w-100 mt-3">
                            Crear Curso
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CrearCurso;
